<div class="modal-header">
  <span class="modal-title" id="modal-title">Associated Product - {{partNumber}}</span>
  <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <app-product-configurations [configurationFilter]="configurationFilter$|async" [partNumber]="partNumber || ''"
                              [configurations]="(configurationsWithFilter$ | async) || []"
                              [referrer]="'associatedProduct'"
                              [configurationsWithoutFilter]="(configurationsWithoutFilter$ | async) || []"
                              [configurationFilterIsApplied]="(hasFilterApplied$ | async) || false"
                              [tappedHoleOptions]="(tappedHoleOptions$ | async) || []"
                              [oringOptions]="(oringOptions$ | async) || []"
                              [bevelOptions]="(bevelOptions$ | async) || []"
                              (liftingLugsChanged)="configurationAssociatePartFilterChange({liftingLugs: $event})"
                              (magInspectionChanged)="configurationAssociatePartFilterChange({magInspection: $event})"
                              (buyAmericaChanged)="configurationAssociatePartFilterChange({buyAmerica: $event})"
                              (tappedBlindChanged)="configurationAssociatePartFilterChangeTappedBlindOption($event)"
                              (oringChanged)="configurationAssociatePartFilterChangeOringOption($event)"
                              (bevelChanged)="configurationAssociatePartFilterChangeBevelOption($event)">
  </app-product-configurations>
</div>
<div class=" modal-footer">
  <button type="button" class="btn btn-secondary" (click)="clearActiveFilter()">Close</button>
</div>